export enum EMBEDDED_CONFLUENCE_CONTENT_TYPE {
	PAGE = 'page',
	BLOGPOST = 'blogpost',
	WHITEBOARD = 'whiteboard',
}
